import { BASE_ADMIN_PATH, getBaseRequestConfig } from './baseRequestConfig';
import httpRequest from './httpRequest';

export function getSponsors(accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/sponsors`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function getSponsor(sponsorId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/sponsors/${sponsorId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function postSponsor(body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/sponsors`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function putSponsor(sponsorId, body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/sponsors/${sponsorId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function deleteSponsor(sponsorId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/sponsors/${sponsorId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'DELETE',
  });

  return httpRequest(requestConfig);
}
